import React, { useState, useEffect, useRef } from "react";
import ShortManInfo from "./shortItem";
import { UserShortInfo } from "../../types";

const ManShortSelector = (props: {
  items: UserShortInfo[];
  enabledAll?: boolean;
  onChangeCallback: (id: number) => void;
  defaultSelectedId?: number;
}) => {
  const { items, onChangeCallback, defaultSelectedId } = props;
  const [query, setQuery] = useState<string>("");
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const [selectedUser, setSelectedUser] = useState<UserShortInfo | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null); // Ref для отслеживания кликов вне компонента

  // Устанавливаем пользователя по умолчанию
  useEffect(() => {
    if (defaultSelectedId) {
      const defaultUser = items.find((item) => item.id === defaultSelectedId);
      if (defaultUser) {
        setSelectedUser(defaultUser);
        onChangeCallback(defaultSelectedId);
      }
    }
  }, [defaultSelectedId, items, onChangeCallback]);

  // Фильтрация элементов
  const filteredItems = items.filter(
    (item) =>
      item.name?.toLowerCase().includes(query.toLowerCase()) ||
      item.phone?.includes(query)
  );

  // Обработчик выбора пользователя
  const handleSelect = (user: UserShortInfo) => {
    setSelectedUser(user);
    onChangeCallback(user.id!);
    setIsDropdownOpen(false);
    setQuery("");
  };

  // Обработчик кликов вне компонента
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false); // Сворачиваем список
      }
    };

    // Добавляем обработчик на документ
    document.addEventListener("mousedown", handleClickOutside);

    // Убираем обработчик при размонтировании компонента
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="manShortSelector" ref={dropdownRef}>
      <div className="dropdown">
        <div
          className="dropdownInput"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        > 
          {selectedUser?.id === 0 && <span>Все</span>}
          {selectedUser ? (
            <ShortManInfo {...selectedUser} />
          ) : (
            <span>{"  "}</span>
          )}
        </div>
        {isDropdownOpen && (
          <div className="dropdownMenu">
            <input
              type="text"
              placeholder="Поиск"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="dropdownSearch"
            />
            <div className="dropdownItems">
              {props.enabledAll && <div className="dropdownItem" 
              onClick={() => handleSelect({ id: 0})}>
                  Все
              </div>}
              {filteredItems.map((item) => (
                <div
                  key={item.id}
                  className="dropdownItem"
                  onClick={() => handleSelect(item)}
                >
                  <ShortManInfo {...item} />
                </div>
              ))}
              {filteredItems.length === 0 && (
                <div className="dropdownNoResults">Нет совпадений</div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ManShortSelector;